// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.all-grades-container {
  display: flex;
}
.all-grades-container .yellow-test {
  background: #FEBF31;
  border: none;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 65px;
  height: 60px;
  color: #19608f;
  font-weight: 550;
  font-size: 1.4rem;
  margin-right: 10px;
  transition: 0.2s ease;
}
.all-grades-container .yellow-test:disabled {
  background: #D1D3D4;
  color: #A7A9AC;
  cursor: no-drop;
}
.all-grades-container .yellow-test:disabled:hover {
  background: #A7A9AC;
  color: #D1D3D4;
}
.all-grades-container .yellow-test:hover {
  cursor: no-drop;
}

.applying-grade-container {
  display: flex;
  align-items: center;
  margin-top: 20px !important;
}
.applying-grade-container .spaceLeft-spaceRight {
  margin: 0 30px;
}
.applying-grade-container .outer {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.applying-grade-container .outer p {
  font-weight: 600;
  margin-bottom: -1px;
}
.applying-grade-container .current-grade-number {
  background: #63AEDE;
  background: #0669B3;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  height: 160px;
  min-width: 160px;
  font-size: 7rem;
  padding: 0px 15px;
  font-weight: 550;
}
.applying-grade-container .applying-grade-number {
  background: #FEBF31;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  height: 160px;
  min-width: 160px;
  font-size: 7rem;
  font-weight: 550;
  padding: 0px 15px;
  color: #19608f;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/GradeLevelBlock.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,aAAA;AAUJ;AARI;EACI,mBDUI;ECTJ,YAAA;ECLJ,kBDM0B;EACtB,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cDPE;ECQF,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;AAUR;AATQ;EACI,mBDFJ;ECGI,cDFJ;ECGI,eAAA;AAWZ;AAVY;EACI,mBDLR;ECMQ,cDPR;ACmBR;AATQ;EACI,eAAA;AAWZ;;AAPA;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;AAUJ;AARI;EACI,cAAA;AAUR;AARI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AAUR;AATQ;EACI,gBAAA;EACA,mBAAA;AAWZ;AAPI;EACI,mBDzBQ;EC0BR,mBD7BK;EEtBT,mBDoD0B;EACtB,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AASR;AAPI;EACI,mBDlDI;EEdR,mBDiE0B;EACtB,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cDtEE;AC+EV","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// Open Enrollment colors\n$lt-blue: #7DB7CC;\n// $dk-blue: #094166;\n$dk-blue: #19608f;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$dk-pearl-blue: #065b9d;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.all-grades-container {\n    display: flex;\n\n    .yellow-test {\n        background: $important;\n        border: none;\n        @include borderRadius(5px);\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        width: 65px;\n        height: 60px;\n        color: $dk-blue;\n        font-weight: 550;\n        font-size: 1.4rem;\n        margin-right: 10px;\n        transition: 0.2s ease;\n        &:disabled {\n            background: $grey1;\n            color: $grey2;\n            cursor: no-drop;\n            &:hover {\n                background: $grey2;\n                color: $grey1;\n            }\n        }\n        &:hover {\n            cursor: no-drop;\n        }\n    }\n}\n.applying-grade-container {\n    display: flex;\n    align-items: center;\n    margin-top: 20px !important;\n\n    .spaceLeft-spaceRight {\n        margin: 0 30px;\n    }\n    .outer {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        p {\n            font-weight: 600;\n            margin-bottom: -1px;\n        }\n    }\n\n    .current-grade-number {\n        background: $lt-pearl-blue;\n        background: $pearl-blue;\n        @include borderRadius(20px);\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        color: white;\n        height: 160px;\n        min-width: 160px;\n        font-size: 7rem;\n        padding: 0px 15px;\n        font-weight: 550;\n    }\n    .applying-grade-number {\n        background: $important;\n        @include borderRadius(20px);\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        color: white;\n        height: 160px;\n        min-width: 160px;\n        font-size: 7rem;\n        font-weight: 550;\n        padding: 0px 15px;\n        color: $dk-blue;\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
